// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.sponsoredSearchResult {
  padding-top: 2.5rem;
  width: 50%;
  cursor: pointer; }
  .sponsoredSearchResult .callUs {
    display: flex;
    align-items: center;
    border: 1px solid #dadce0;
    gap: 1rem;
    border-radius: 2rem;
    padding: 1rem 0.8rem;
    width: 8rem;
    font-size: 1.4rem; }
    .sponsoredSearchResult .callUs i {
      color: #1a0dab; }
    .sponsoredSearchResult .callUs span {
      color: #1a0dab;
      padding-left: 1rem; }
  .sponsoredSearchResult .webInfoContainer {
    display: flex;
    align-items: center;
    gap: 1.2rem;
    margin-top: 1rem;
    cursor: pointer; }
    .sponsoredSearchResult .webInfoContainer .icon {
      background-color: #e2eeff;
      border: 1px solid #dadce0;
      padding: 0.5rem;
      border-radius: 50%; }
      .sponsoredSearchResult .webInfoContainer .icon i {
        color: #1a0dab;
        font-size: 1.8rem; }
    .sponsoredSearchResult .webInfoContainer .webDetail {
      display: flex;
      align-items: flex-start;
      flex-direction: column;
      gap: 0.3rem; }
      .sponsoredSearchResult .webInfoContainer .webDetail__title {
        font-size: 1.4rem;
        color: #202124; }
      .sponsoredSearchResult .webInfoContainer .webDetail__linkContainer {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        font-size: 1.2rem; }
        .sponsoredSearchResult .webInfoContainer .webDetail__linkContainer__moreBtn {
          background-color: transparent;
          border: none; }
        .sponsoredSearchResult .webInfoContainer .webDetail__linkContainer svg {
          background-color: transparent;
          border: none; }
        .sponsoredSearchResult .webInfoContainer .webDetail__linkContainer__link {
          color: #4d5156; }
  .sponsoredSearchResult .searchResultDetailContainer {
    display: flex;
    align-items: center;
    gap: 1rem; }
    .sponsoredSearchResult .searchResultDetailContainer .searchResultDetail {
      width: 100%; }
      .sponsoredSearchResult .searchResultDetailContainer .searchResultDetail__title {
        font-size: 2rem;
        line-height: 2.6rem;
        color: #1a0dab;
        font-weight: 400;
        margin: 0.8rem 0;
        cursor: pointer;
        text-overflow: ellipsis;
        width: 80%;
        overflow: hidden;
        white-space: nowrap; }
        .sponsoredSearchResult .searchResultDetailContainer .searchResultDetail__title:hover {
          text-decoration: underline; }
      .sponsoredSearchResult .searchResultDetailContainer .searchResultDetail__des {
        color: #4d5156;
        font-size: 1.4rem;
        overflow: hidden;
        text-overflow: ellipsis;
        margin: 0.8rem 0;
        max-height: 10rem;
        line-height: 1.58;
        margin-bottom: 0; }
      .sponsoredSearchResult .searchResultDetailContainer .searchResultDetail .descriptionList {
        list-style: none; }
        .sponsoredSearchResult .searchResultDetailContainer .searchResultDetail .descriptionList .listTitle {
          font-size: 2rem;
          line-height: 2.6rem;
          color: #1a0dab;
          font-weight: 400;
          margin: 0.8rem 0;
          cursor: pointer;
          text-overflow: ellipsis;
          width: 80%;
          overflow: hidden;
          white-space: nowrap; }
          .sponsoredSearchResult .searchResultDetailContainer .searchResultDetail .descriptionList .listTitle:hover {
            text-decoration: underline; }
        .sponsoredSearchResult .searchResultDetailContainer .searchResultDetail .descriptionList .listDes {
          color: #4d5156;
          font-size: 1.4rem;
          overflow: hidden;
          text-overflow: ellipsis;
          margin: 0.8rem 0;
          max-height: 10rem;
          line-height: 1.58; }
      .sponsoredSearchResult .searchResultDetailContainer .searchResultDetail .deals {
        font-size: 1.4rem;
        color: #4d5156;
        margin-top: 0.5rem; }
        .sponsoredSearchResult .searchResultDetailContainer .searchResultDetail .deals span {
          font-weight: bold; }
      .sponsoredSearchResult .searchResultDetailContainer .searchResultDetail .location {
        font-size: 1.4rem;
        color: #4d5156; }
      .sponsoredSearchResult .searchResultDetailContainer .searchResultDetail .services {
        padding-top: 0.5rem;
        display: flex;
        align-items: center;
        list-style: none;
        /* Remove default bullet points */
        padding: 0;
        color: #1a0dab; }
        .sponsoredSearchResult .searchResultDetailContainer .searchResultDetail .services li {
          position: relative;
          /* Position relative for pseudo-elements */
          padding-left: 1.2rem;
          /* Adjust the padding as needed */
          margin-bottom: 1rem;
          /* Adjust the margin as needed */ }
          .sponsoredSearchResult .searchResultDetailContainer .searchResultDetail .services li:first-child {
            padding-left: 0; }
          .sponsoredSearchResult .searchResultDetailContainer .searchResultDetail .services li::before {
            content: "•";
            /* Custom bullet point content */
            position: absolute;
            left: 0;
            font-size: 1.6rem;
            color: #1a0dab;
            bottom: -30%;
            left: 3%; }
      .sponsoredSearchResult .searchResultDetailContainer .searchResultDetail .services li:first-child::before {
        /* Remove the custom bullet point for the first list item */
        content: "";
        padding-left: 0; }
    .sponsoredSearchResult .searchResultDetailContainer img {
      width: 100px;
      border-radius: 1rem; }
  .sponsoredSearchResult .ratingContainer {
    display: flex;
    align-items: center;
    font-size: 1.4rem;
    color: #70757a; }
    .sponsoredSearchResult .ratingContainer .rating {
      padding-left: 0.5rem; }
    .sponsoredSearchResult .ratingContainer .itemIcon {
      margin-bottom: 0.7rem; }
      .sponsoredSearchResult .ratingContainer .itemIcon .fa-star {
        color: #fbbc04; }
    .sponsoredSearchResult .ratingContainer .stars {
      width: 1.5rem; }
      .sponsoredSearchResult .ratingContainer .stars img {
        width: 100%; }
`, "",{"version":3,"sources":["webpack://./src/components/SponsoredAds/index.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,mBAAmB;EACnB,UAAU;EACV,eAAe,EAAA;EAHjB;IAKI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,SAAS;IACT,mBAAmB;IACnB,oBAAoB;IACpB,WAAW;IACX,iBAAiB,EAAA;IAZrB;MAcM,cAAc,EAAA;IAdpB;MAiBM,cAAc;MACd,kBAAkB,EAAA;EAlBxB;IAsBI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,eAAe,EAAA;IA1BnB;MA4BM,yBAAyB;MACzB,yBAAyB;MACzB,eAAe;MACf,kBAAkB,EAAA;MA/BxB;QAiCQ,cAAc;QACd,iBAAiB,EAAA;IAlCzB;MAsCM,aAAa;MACb,uBAAuB;MACvB,sBAAsB;MACtB,WAAW,EAAA;MAzCjB;QA2CQ,iBAAiB;QACjB,cAAc,EAAA;MA5CtB;QA+CQ,aAAa;QACb,mBAAmB;QACnB,WAAW;QACX,iBAAiB,EAAA;QAlDzB;UAoDU,6BAA6B;UAC7B,YAAY,EAAA;QArDtB;UAwDU,6BAA6B;UAC7B,YAAY,EAAA;QAzDtB;UA4DU,cAAc,EAAA;EA5DxB;IAkEI,aAAa;IACb,mBAAmB;IACnB,SAAS,EAAA;IApEb;MAsEM,WAAW,EAAA;MAtEjB;QAwEQ,eAAe;QACf,mBAAmB;QACnB,cAAc;QACd,gBAAgB;QAChB,gBAAgB;QAChB,eAAe;QACf,uBAAuB;QACvB,UAAU;QACV,gBAAgB;QAChB,mBAAmB,EAAA;QAjF3B;UAmFU,0BAA0B,EAAA;MAnFpC;QAuFQ,cAAc;QACd,iBAAiB;QACjB,gBAAgB;QAChB,uBAAuB;QACvB,gBAAgB;QAChB,iBAAiB;QACjB,iBAAiB;QACjB,gBAAgB,EAAA;MA9FxB;QAiGQ,gBAAgB,EAAA;QAjGxB;UAmGU,eAAe;UACf,mBAAmB;UACnB,cAAc;UACd,gBAAgB;UAChB,gBAAgB;UAChB,eAAe;UACf,uBAAuB;UACvB,UAAU;UACV,gBAAgB;UAChB,mBAAmB,EAAA;UA5G7B;YA8GY,0BAA0B,EAAA;QA9GtC;UAkHU,cAAc;UACd,iBAAiB;UACjB,gBAAgB;UAChB,uBAAuB;UACvB,gBAAgB;UAChB,iBAAiB;UACjB,iBAAiB,EAAA;MAxH3B;QA4HQ,iBAAiB;QACjB,cAAc;QACd,kBAAkB,EAAA;QA9H1B;UAgIU,iBAAiB,EAAA;MAhI3B;QAoIQ,iBAAiB;QACjB,cAAc,EAAA;MArItB;QAwIQ,mBAAmB;QACnB,aAAa;QACb,mBAAmB;QACnB,gBAAgB;QAAE,iCAAA;QAClB,UAAU;QACV,cAAc,EAAA;QA7ItB;UA+IU,kBAAkB;UAAE,0CAAA;UACpB,oBAAoB;UAAE,iCAAA;UACtB,mBAAmB;UAAE,gCAAA,EAAiC;UAjJhE;YAmJY,eAAe,EAAA;UAnJ3B;YAsJY,YAAS;YAAM,gCAAA;YACf,kBAAkB;YAClB,OAAO;YACP,iBAAiB;YACjB,cAAc;YACd,YAAY;YACZ,QAAQ,EAAA;MA5JpB;QAiKQ,2DAAA;QACA,WAAW;QACX,eAAe,EAAA;IAnKvB;MAuKM,YAAY;MACZ,mBAAmB,EAAA;EAxKzB;IA4KI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,cAAc,EAAA;IA/KlB;MAiLM,oBAAoB,EAAA;IAjL1B;MAoLM,qBAAqB,EAAA;MApL3B;QAsLQ,cAAc,EAAA;IAtLtB;MA0LM,aAAa,EAAA;MA1LnB;QA4LQ,WAAW,EAAA","sourcesContent":[".sponsoredSearchResult {\n  padding-top: 2.5rem;\n  width: 50%;\n  cursor: pointer;\n  .callUs {\n    display: flex;\n    align-items: center;\n    border: 1px solid #dadce0;\n    gap: 1rem;\n    border-radius: 2rem;\n    padding: 1rem 0.8rem;\n    width: 8rem;\n    font-size: 1.4rem;\n    i {\n      color: #1a0dab;\n    }\n    span {\n      color: #1a0dab;\n      padding-left: 1rem;\n    }\n  }\n  .webInfoContainer {\n    display: flex;\n    align-items: center;\n    gap: 1.2rem;\n    margin-top: 1rem;\n    cursor: pointer;\n    .icon {\n      background-color: #e2eeff;\n      border: 1px solid #dadce0;\n      padding: 0.5rem;\n      border-radius: 50%;\n      i {\n        color: #1a0dab;\n        font-size: 1.8rem;\n      }\n    }\n    .webDetail {\n      display: flex;\n      align-items: flex-start;\n      flex-direction: column;\n      gap: 0.3rem;\n      &__title {\n        font-size: 1.4rem;\n        color: #202124;\n      }\n      &__linkContainer {\n        display: flex;\n        align-items: center;\n        gap: 0.5rem;\n        font-size: 1.2rem;\n        &__moreBtn {\n          background-color: transparent;\n          border: none;\n        }\n        svg {\n          background-color: transparent;\n          border: none;\n        }\n        &__link {\n          color: #4d5156;\n        }\n      }\n    }\n  }\n  .searchResultDetailContainer {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    .searchResultDetail {\n      width: 100%;\n      &__title {\n        font-size: 2rem;\n        line-height: 2.6rem;\n        color: #1a0dab;\n        font-weight: 400;\n        margin: 0.8rem 0;\n        cursor: pointer;\n        text-overflow: ellipsis;\n        width: 80%;\n        overflow: hidden;\n        white-space: nowrap;\n        &:hover {\n          text-decoration: underline;\n        }\n      }\n      &__des {\n        color: #4d5156;\n        font-size: 1.4rem;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        margin: 0.8rem 0;\n        max-height: 10rem;\n        line-height: 1.58;\n        margin-bottom: 0;\n      }\n      .descriptionList {\n        list-style: none;\n        .listTitle {\n          font-size: 2rem;\n          line-height: 2.6rem;\n          color: #1a0dab;\n          font-weight: 400;\n          margin: 0.8rem 0;\n          cursor: pointer;\n          text-overflow: ellipsis;\n          width: 80%;\n          overflow: hidden;\n          white-space: nowrap;\n          &:hover {\n            text-decoration: underline;\n          }\n        }\n        .listDes {\n          color: #4d5156;\n          font-size: 1.4rem;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          margin: 0.8rem 0;\n          max-height: 10rem;\n          line-height: 1.58;\n        }\n      }\n      .deals {\n        font-size: 1.4rem;\n        color: #4d5156;\n        margin-top: 0.5rem;\n        span {\n          font-weight: bold;\n        }\n      }\n      .location {\n        font-size: 1.4rem;\n        color: #4d5156;\n      }\n      .services {\n        padding-top: 0.5rem;\n        display: flex;\n        align-items: center;\n        list-style: none; /* Remove default bullet points */\n        padding: 0;\n        color: #1a0dab;\n        li {\n          position: relative; /* Position relative for pseudo-elements */\n          padding-left: 1.2rem; /* Adjust the padding as needed */\n          margin-bottom: 1rem; /* Adjust the margin as needed */\n          &:first-child {\n            padding-left: 0;\n          }\n          &::before {\n            content: \"•\"; /* Custom bullet point content */\n            position: absolute;\n            left: 0;\n            font-size: 1.6rem;\n            color: #1a0dab;\n            bottom: -30%;\n            left: 3%;\n          }\n        }\n      }\n      .services li:first-child::before {\n        /* Remove the custom bullet point for the first list item */\n        content: \"\";\n        padding-left: 0;\n      }\n    }\n    img {\n      width: 100px;\n      border-radius: 1rem;\n    }\n  }\n  .ratingContainer {\n    display: flex;\n    align-items: center;\n    font-size: 1.4rem;\n    color: #70757a;\n    .rating {\n      padding-left: 0.5rem;\n    }\n    .itemIcon {\n      margin-bottom: 0.7rem;\n      .fa-star {\n        color: #fbbc04;\n      }\n    }\n    .stars {\n      width: 1.5rem;\n      img {\n        width: 100%;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
